<template>
  <div class="media act-media">
    <div class="media-body act-media-body">
      <div class="activity-header d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <a class="float-left avatar-class" href="#">
            <Avatar
              class="rounded-circle"
              :name="activity.user.name || activity.user.email"
              :url="activity.user.gravatar"
              width="32"
            />
          </a>
          <strong class="name ml-2">{{ activity.user.name }}</strong>
          <small class="ml-2">
            <span>
              <i :class="activity.type.icon" />
              {{ __(activity.type.name) }}
            </span>
            <LeadActivityFollowers
              put="put"
              small-icon="small-icon"
              :lead="hash"
              :activity="activity.id"
              :active-users="activity.followers"
            />
          </small>
        </div>
        <div class="ml-auto d-flex align-items-center">
          <div v-if="isFixedActivity" class="tooltip-wrapper">
            <button
              class="icon-check-button unpin-button" 
              @click="unpin({activity, isFixing: false})"
              @mouseenter="isHoveredFixedBtn = true" 
              @mouseleave="isHoveredFixedBtn = false"
            >
              <IconPaperPinOutline />
            </button>
            <div v-if="isHoveredFixedBtn" class="tooltip-container">
              <div class="tooltip-arrow"></div>
              <div class="tooltip-content">
                  {{ __("Desafixar") }}
              </div>
            </div>
          </div>
          <div v-if="false" class="tooltip-wrapper ml-2">
            <button 
              class="icon-check-button" 
              @click="finishActivity(activity)"
              @mouseenter="isHoveredFinishedBtn = true" 
              @mouseleave="isHoveredFinishedBtn = false"
            >
              <IconCheck size="13" :color="isHoveredFinishedBtn ? '#FFFFFF' : '#886AF8'"></IconCheck>
            </button>
            <div v-if="isHoveredFinishedBtn" class="tooltip-container">
              <div class="tooltip-arrow"></div>
              <div class="tooltip-content">
                  {{ __("Finalizar") }}
              </div>
            </div>
          </div>
          <div class="tooltip-wrapper">
            <button
              class="finished-btn-small ml-2"
              :class="{
                'finished-successfully': activity.completed_status === 'successfully',
                'finished-unsuccessfully': activity.completed_status === 'unsuccessfully'
              }"
              disabled="disabled"
              v-show="false"
              @mouseenter="isHoveredStatus = true" 
              @mouseleave="isHoveredStatus = false"
            >
              <img 
                :src="statusIcon"
                class="status-icon"
              />
            </button>
            <div v-if="isHoveredStatus" class="tooltip-container">
              <div class="tooltip-arrow"></div>
              <div class="tooltip-content">
                  {{ activity.completed_status == 'successfully' ? __('Finalizado com sucesso') : __('Finalizado sem sucesso') }}
              </div>
            </div>
          </div>
          <div class="ml-2">
            <DropdownActions 
              :activity="activity" 
              :fixedActivitiesCount="fixedItemsCount" 
              :totalFixedActivities="totalFixedActivities"
              @updateFixedActivityCount="updateFixedActivityCount"
              @unpin="unpin"
              @edit-activity="edit"
            />
          </div>
        </div>
      </div>
      <div class="activity-content" :class="{ 'deleted-text-color': activity.deleted_at }">
        <div v-if="inEdition" class="editing-box">
          <LeadActivityEdit
            class="form-group form-control activity-edit"
            :activity="activity"
            :isEditing="inEdition"
            @input="onInputActivityUpdated"
          />
        </div>
          <!-- <template v-slot:summary>
            <SummaryEdit 
              @summaryCreated="setSummary"
              @discardSummary="discardSummary"
              :summary="activity.summary"
              @update:summary="setSummary"
              @summaryWasEdited="onSummaryWasEdited"
            />
          </template> -->
          <div class="d-flex justify-content-end align-items-center mt-3" v-if="inEdition">
          <button
            class="btn btn-sm btn-white text-danger mr-2"
            @click="cancel()"
          >
            {{ __('Cancelar') }}
          </button>
          <button class="btn btn-sm btn-box-success" @click="save()">
            {{ __('Salvar') }}
          </button>
        </div>
        <!-- If the activity has a summary and the content, show the summary with a different style -->
        <div v-else>
          <!-- Here is the content of the activity -->
          <div v-if="activity.content && removeTags(activity.content).trim() !== ''" class="form-group" v-html="format(activity.content)" />
          <div v-if="!hasOnlySummary" class="summary-wrapper d-flex mt-0 gap-1" :class="{ 'mt-2': hasSummaryAndContent }">
            <Tooltip 
              :title="__('Criado com') + ' SelliA'" 
              placement="bottom" 
              tooltipClass="custom-sellia-tooltip"
              style="height: fit-content;"
            >
              <IconTwoFourPointedStar v-if="hasSummaryAndContent" size="16" color="#8869FD" hoverColor="#8869FD"/> 
            </Tooltip>
            <div class="form-group p-0 m-0 fs-9 lh-18 fw-400 w-100" :class="{ 'text-custom-purple px-2': hasSummaryAndContent}" v-html="format(activity.summary)"/>
          </div>
        </div>
        <!-- The indicator that this only text is a summary made by Sellia -->
        <div v-if="hasOnlySummary && !summaryWasUpdated" class="made-by-sellia text-custom-purple fs-8 lh-18 fw-500 d-flex gap-1 mt-2">
          <Tooltip 
            :title="__('Criado com') + ' SelliA'" 
            placement="bottom" 
            tooltipClass="custom-sellia-tooltip"
            style="height: fit-content;"
          >
            <IconTwoFourPointedStar size="16" color="#8869FD" hoverColor="#8869FD"/>
          </Tooltip>
          <span class="text-custom-purple">{{ format(activity.summary) }}</span>
        </div>
        <div v-else-if="hasOnlySummary && summaryWasUpdated" class="made-by-sellia text-custom-purple fs-8 lh-18 fw-500 d-flex flex-column gap-1 mt-10px">
          <div class="d-flex gap-1">
            <Tooltip 
              :title="__('Criado com') + ' SelliA'" 
              placement="bottom" 
              tooltipClass="custom-sellia-tooltip"
              style="height: fit-content;"
            >
              <IconTwoFourPointedStar class="mr-2px" size="16" color="#8869FD" hoverColor="#8869FD"/>
            </Tooltip>
            <span class="text-custom-purple">{{ format(activity.summary) }}</span>
          </div>
          <div class="summary-updated-text">
            {{ __('Editado em') }} {{ activity.summary_updated_at | date }} {{ __('às') }} {{ activity.summary_updated_at | time }} {{ __('por') }} {{ activity.summary_updated_by.name }}
          </div>
        </div>
        <div v-else-if="summaryWasUpdated" class="made-by-sellia text-custom-purple fs-8 lh-18 fw-500 d-flex gap-1 mt-10px">
          <div class="summary-updated-text">
            {{ __('Editado em') }} {{ activity.summary_updated_at | date }} {{ __('às') }} {{ activity.summary_updated_at | time }} {{ __('por') }} {{ activity.summary_updated_by.name }}
          </div>
        </div>
        <img
          v-if="
            file.extension == 'png' ||
            file.extension == 'jpg' ||
            file.extension == 'jpeg'
          "
          :src="file.signedUrl"
          class="img-fluid shadow rounded"
          style="max-width: 100px"
        />
        <LeadActivityData :activity="activity" v-if="activity.data" />
      </div>
      <small>
        <span v-b-tooltip.left="formatDate(activity.created_at)" class="mr-3">
          {{ activity.created_at | ago }}
        </span>
        <a v-if="activity.file_id" :href="file.signedUrl" target="_blank" download class="mr-3">
          <i class="fa fa-download"></i> {{ file.formatted }}
        </a>
        <span v-if="!deal && activity.deal" class="mr-3">
          <a :href="'/deal#/' + activity.deal.hashid" target="_blank">
            {{ __('Negócio') }}
            <span class="font-italic">{{ '#' + activity.deal.id }}</span>
          </a>
        </span>
        <span class="mr-3 deleted-text" v-if="activity.deleted_at">
          <IconClockHistory :size="13"/>
          {{__('Excluído em')}}: {{ activity.deleted_at | date }} {{ __('às') }} {{ activity.deleted_at | time }}
        </span>
        <span v-if="activity.deleted_at" class="deleted-text">
          <IconThinThrashCan :size="13" />
          {{ __('Excluído por') }}: {{ activity.deleted_by.name }}
        </span>
      </small>
      <div
        class="d-flex align-items-center"
        v-if="activity.scheduled_at"
      >
        <small
          class="mr-2"
          :class="{
            completed: activity.completed_at,
            delayed: isDelayed(activity),
          }"
          v-if="!activity.deleted_at"
        >
          <i class="fa fa-clock-o mr-2" v-b-tooltip="__('Agendamento')" />
          <span class="mr-1">
            {{ __('Prazo:') }} {{ activity.scheduled_at | datetime }}
          </span>
          <i
            class="fa fa-exclamation-triangle delayed mr-1"
            v-b-tooltip="__('Atraso')"
            v-if="isDelayed(activity)"
          />
        </small>
        <small
          class="lead-activity-schedule mr-2"
          v-if="activity.type.key !== 'note' && !activity.deleted_at"
        >
          <span
            class="d-flex align-items-center"
            v-if="!schedule.active && !activity.completed_at"
          >
            <button
              class="btn btn-sm btn-white pl-0 mr-2"
              @click="schedule.active = true"
            >
              <i class="fa fa-calendar mr-2" />
              <span>{{ __('Editar agendamento') }}</span>
            </button>
          </span>
          <span class="d-flex align-items-center" v-if="schedule.active">
            <span class="mr-2 flex-shrink-0">
              {{ __('Reagendar para') }}
            </span>
            <InputDateTimepickerForActivities
              input-class="form-control date mr-2"
              v-model="schedule.date"
              :users="this.activity?.followers?.map(f => f.id)"
              :deal-id="this.deal?.id"
              :lead-hashid="this.hash"
            />
            <span class="mr-2">{{ __('às') }}</span>
            <InputDateTimepickerForActivities
              type="time"
              v-model="schedule.time"
              input-class="form-control time mr-2 activity-list"
              :users="this.activity?.followers?.map(f => f.id)"
              :deal-id="this.deal?.id"
              :lead-hashid="this.hash"
            />
            <button
              class="btn btn-sm btn-box-success mr-2"
              @click="saveScheduled()"
            >
              {{ __('Salvar') }}
            </button>
            <button
              class="btn btn-sm btn-white text-danger mr-2"
              @click="schedule.active = false"
            >
              {{ __('Cancelar') }}
            </button>
          </span>
        </small>
        <small v-if="!schedule.active" class="ml-auto">
          <button
            class="btn btn-sm btn-box-success text-salesflow-font-dark finish-btn"
            @click="finishActivity(activity)"
            v-if="canComplete(activity)"
          >
            {{ __('Finalizar') }}
          </button>
          <button
            class="btn btn-sm btn-white finished-btn"
            disabled="disabled"
            v-show="activity.completed_at && !activity.completed_status && !activity.deleted_at"
          >
            {{ __('Finalizado') }}
          </button>
          <button
            class="btn btn-sm btn-white finished-btn deleted-btn"
            disabled="disabled"
            v-show="activity.deleted_at"
          >
            {{ __('Excluído') }}
          </button>
          <button
            class="finished-btn"
            :class="{
              'finished-successfully': activity.completed_status === 'successfully',
              'finished-unsuccessfully': activity.completed_status === 'unsuccessfully'
            }"
            disabled="disabled"
            v-show="activity.completed_at && activity.completed_status"
          >
            <img 
              :src="statusIcon"
              class="status-icon"
            />
            {{ activity.completed_status == 'successfully' ? __('Finalizado com sucesso') : __('Finalizado sem sucesso') }}
          </button>
        </small>
      </div>
    </div>
    <FinishActivityModal 
      :activityId="activity.id" 
      @confirmFinish="handleFinishActivity" 
    />
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import dayjs from '../../core/dayjs';
import FinishActivityModal from '../activity/FinishActivityModal.vue';
import InputDateTimepickerForActivities from '../input/DateTimePickerForActivities.vue';
import IconCheck from '../icon/Check.vue';
import SummaryEdit from './SummaryEdit.vue';
import DropdownActions from '../activity/DropdownActions.vue';
import Tooltip from '../../components/Tooltip.vue';

export default {
  components: {
    DropdownActions,
    FinishActivityModal,
    IconCheck,
    InputDateTimepickerForActivities,
    SummaryEdit,
    Tooltip
  },

  watch: {
    fixedActivitiesCount: {
      handler(newCount) {
        this.fixedItemsCount = newCount;
      },
      immediate: true
    },
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  computed: {
    totalFixedActivities() {
        return this.$parent.activities.filter(activity => activity.fixed).length;
    },
    hasOnlySummary() {
      return this.activity.summary && this.removeTags(this.activity.content) === '';
    },

    summaryWasUpdated() {
      return this.activity.summary_updated_at && this.activity.summary_updated_by;
    },

    hasSummaryAndContent() {
      return this.activity.summary && this.removeTags(this.activity.content);
    },

    statusIcon() {
      return `/build/icons/${this.activity.completed_status === 'successfully' ? 'happy' : 'sad'}-face.svg`;
    },
  },

  props: ['activity', 'deal', 'hash', 'user', 'fixedActivitiesCount', 'isFixedActivity'],

  data() {
    return {
      inEdition: false,
      content: '',
      schedule: {
        active: false,
        date: this.activity.scheduled_at,
        time: dayjs().add(30, 'minutes').format('HH:mm'),
      },
      file: {},
      isHoveredStatus: false,
      isHoveredFinishedBtn: false,
      followers: [this.user.id],
      isHoveredFixedBtn: false,
      summaryEdition: {
        original: '',
        isEdited: false
      },
      summary: '',
      fixedItemsCount: 0,
    };
  },

  mounted() {
    this.fixedItemsCount = this.fixedActivitiesCount;

    Bus.$emit('listHeightUpdate');
    if (this.activity.file_id != null) {
      this.getFileInfo(this.activity.file_id);
    }
  },

  watch: {
    'schedule.active': function(newValue) {
      if (newValue) {
        this.schedule.time = this.roundToNearest15(new Date());
      }
    },
  },

  methods: {
    roundToNearest15(date) {
      const d = new Date(date);
      const minutes = d.getMinutes();
      const remainder = minutes % 15;
      const roundedMinutes = remainder < 8 ? minutes - remainder : minutes + (15 - remainder);
      
      d.setMinutes(roundedMinutes);
      d.setSeconds(0);
      
      return dayjs(d).format('HH:mm');
    },
    
    edit() {
        this.inEdition = true;
        this.content = this.activity.content;
    },
    
    updateFixedActivityCount(activity) {
      this.$emit('updateFixedActivitiesCount', activity);
    },

    unpin(activity) {
      this.$emit('unpinActivity', activity);
    },
    
    updateFixedActivityCount(activity) {
      if (!activity.activity.fixed && (this.totalFixedActivities) >= 3) {
          return;
      }

      this.$emit('updateFixedActivitiesCount', activity);
    },

    discardSummary() {
      this.summary = '';
      this.activity.summary = '';
    },

    onSummaryWasEdited(editData) {
      this.summaryEdition = editData;
    },

    setSummary(summary) {
      this.summary = summary;
    },

    finishActivity(activity) {
      Bus.$emit('openFinishActivityModal', activity);
    },

    handleFinishActivity({ activity, completed_status, closeModal }) {
      this.$http
        .put(`/lead/${this.hash}/activity/${activity.id}`, {
          complete: true,
          completed_status: completed_status
        })
        .then(({ data }) => {
          Bus.$emit(`lead.${this.hash}.activity.complete`, data);
          Bus.$emit('getBoard');
          closeModal();
        });
    },

    getFileInfo(id) {
      this.$http
        .get(`/api/file/${id}`)
        .then((response) => {
          this.file = response.data;
        })
        .catch(() => {
          this.file = {};
        });
    },

    isDelayed(activity) {
      const delayed =
        activity &&
        activity.scheduled_at &&
        !activity.completed_at &&
        new Date().getTime() > new Date(activity.scheduled_at).getTime();

      return delayed;
    },

    canComplete(activity) {
      if (!activity.scheduled_at) {
        return false;
      }

      if (activity.deleted_at) {
        return false;
      }

      if (activity.completed_at) {
        return false;
      }

      if (!this.user) {
        console.warn('User not found');

        return true;
      }

      if (activity.user.email == this.user.email) {
        return true;
      }

      if (this.user.admin) {
        return true;
      }

      return _.find(activity.followers, (user) => user.id === this.user.id);
    },

    complete(activity) {
      this.$http
        .put(`/lead/${this.hash}/activity/${activity.id}`, { complete: true })
        .then(({ data }) => {
          Bus.$emit(`lead.${this.hash}.activity.complete`, data);
        });
    },

    canEdit() {
      if (!this.user) {
        return true;
      }

      if (this.activity.user.email == this.user.email) {
        return true;
      }

      if (this.user.admin) {
        return true;
      }

      return false;
    },

    edit() {
      this.inEdition = true;
      this.content = this.activity.content;
    },

    cancel() {
      this.inEdition = false;
      // eslint-disable-next-line vue/no-mutating-props
      this.activity.content = this.content;
    },

    save() {
      this.inEdition = false;

      this.$http
        .put(`/lead/${this.hash}/activity/${this.activity.id}`, {
          id: this.activity.id,
          content: this.activity.content,
        })
        .then(() => {
          Bus.$emit('listHeightUpdate');
          Bus.$emit('activity-updated', '');
        });
    },

    saveScheduled() {
      this.inEdition = false;

      this.$http
        .put(`/lead/${this.hash}/activity/${this.activity.id}`, {
          scheduled_at: `${this.schedule.date.split(' ')[0]} ${this.schedule.time}`,
        })
        .then(({ data }) => {
          Bus.$emit(`lead.${this.hash}.activity.scheduled`, data);
          Bus.$emit('activity-updated');
          this.schedule.active = false;
        })
        .catch((response) => {
          if (response.status === 422) {
            if (typeof response.data.scheduled_at[0] !== 'undefined') {
              return Alert.error(response.data.scheduled_at[0]);
            }

            return Alert.error(this.__('Data de agendamento inválida.'));
          }

          Alert.error(
            this.__('Erro ao salvar atividade. Tente novamente mais tarde.'),
          );
        })
        .finally(() => {
          this.saving = false;
        });
    },

    mentions(str) {
      return str
        .replace(
          /"(\w+)">(@[\w\s\-'áàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]*)</g,
          '"$1"><a href="/user/$1/profile">$2</a><',
        )
        .replace(
          /(@[\w\s\-'áàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]*)#(\w+)/g,
          '<a href="/user/$2/profile" class="mention">$1</a>',
        );
    },

    removeTags(str) {
      return str.replace(/<[^>]*>/g, '');
    },

    format(str) {
      if (str != null) {
        return this.mentions(str.replace(/<p><\/p>/g, '<p><br></p>'));
      }
      return '';
    },

    formatDate(date) {
      return dayjs(date).format('LDT');
    },

    onInputActivityUpdated(event) {
      const plainTextOld = this.content.replace(/<[^>]*>/g, '');
      const plainTextNew = event.replace(/<[^>]*>/g, '');

      if (plainTextOld != plainTextNew) {
        this.$emit('activity-updated', 'hasChanges');
      } else {
        this.$emit('activity-updated', null);
      }
    }
  },

  filters: {
    time(value) {
      if (!value) return '';
      return dayjs(value).format('HH:mm');
    }
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/variables';

.media.act-media {
  padding: 16px 0 !important;
}

.media-body.act-media-body {
  display: flex;
  flex-direction: column;
  gap: 6px !important;
}

.activity-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.name {
  font-family: Inter !important;
}

.activity-content {
  padding: 8px 0 !important;
  margin-bottom: 0 !important;

  ::v-deep {
    p {
      margin-bottom: 0 !important;
    }
  }
}

.lead-activity-schedule {
  span {
    color: var(--Colors-Font-Gray, var(--Sales-for-whats-Font-Gray, #71767D));
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;

  }

  ::v-deep .activity-list {
    margin-bottom: 0 !important;
  }
}

.finish-btn {
  display: flex;
  padding: 4px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: $salesflow-purple-extra-light;
  color: $salesflow-font-dark;
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
}

.finish-btn:hover {
  background: $salesflow-font-purple-light !important;
}

.finished-btn {
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  border:none;
}

.finished-successfully {
  display: flex;
  width: 181px;
  height: 26px;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: #D1FFCA99;
  color: #0F9030 !important;

  .status-icon {
    filter: invert(43%) sepia(85%) saturate(489%) hue-rotate(95deg) brightness(60%) contrast(97%);
  }
}

.finished-unsuccessfully {
  display: flex;
  width: 180px;
  height: 26px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: #FBD9D7;
  color: #FF3B30;

  .status-icon {
    filter: invert(37%) sepia(95%) saturate(7471%) hue-rotate(353deg) brightness(101%) contrast(108%);
  }
}

.status-icon {
  width: 18px;
  height: 18px;
}

.icon-check-button {
  display: flex;
  width: 26px;
  height: 26px;
  padding: 6px 3.5px 4px 3.5px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #ECE7FF;
  background: #F4F1FF;

  &:hover {
    border-radius: 8px;
    border: 1px solid #ECE7FF;
    background: #886AF8;
  }
}

.finished-btn-small {
  display: flex;
  width: 26px;
  height: 26px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border: 1px solid #ECE7FF;

  &.finished-successfully {
    &:hover {
      background: #BEFFB2;
      border-color: #49A235;
    }
  }

  &.finished-unsuccessfully {
    &:hover {
      background: #FFC5C1;
      border-color: #FF8E88;
    }
  }
}

.tooltip-wrapper {
  position: relative !important;
}

.tooltip-container {
  position: absolute !important;
  bottom: -38px !important;
  left: 60% !important;
  transform: translateX(-50%) !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  z-index: 1000 !important;
  top: 36px !important;
  width:auto;
}

.tooltip-arrow {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #000000;
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
}

.tooltip-content {
  background: #000000;
  color: #FFFFFF;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  border-radius: 8px;
  padding: 4px 8px;
  white-space: nowrap;
}

.fs-8 {
  font-size: 12px;
}

.fs-9 {
  font-size: 13px;
}

.lh-18 {
  line-height: 18px;
}

.fw-500 {
  font-weight: 500;
}

.fw-400 {
  font-weight: 400;
}

.text-custom-purple {
  color: #5F33FF;
}

.gap-1 {
  gap: 4px;
}

.deleted-btn {
  font-weight: 400 !important;
  color: #71767D !important;
}

.deleted-text {
  font-family: Inter;
  line-height: 18px;
}

.deleted-text-color {
  color: #AAAAAB;
}

.summary-updated-text {
  color: $salesflow-font-gray;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.avatar-class {
  pointer-events: none;
}

.avatar-class:hover {
  text-decoration: none;
}

.unpin-button {
  background-color: #F4F1FF;
}

.unpin-button:hover {
  background-color: #DCD3FF;
}

.unpin-button:hover svg {
  fill: #DCD3FF !important;
}

.editing-box {
  border: 1px solid #ddd;
  padding: 0px;
  border-radius: 4px;
  margin-bottom: 6px;
}

.custom-sellia-tooltip.tooltip.b-tooltip {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  width: 60px;
  height: 44px;
  filter: drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.12)) drop-shadow(0px 15px 35px rgba(103, 110, 118, 0.08));
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 1;
  background: #000000 !important;
  opacity: 1 !important;
  border-radius: 8px !important;
  margin-top: 8px !important;
}

.custom-sellia-tooltip.tooltip.b-tooltip .arrow {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 20px;
  height: 12px;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: -6px -6px;
}

.custom-sellia-tooltip.tooltip.b-tooltip .arrow::before {
  content: '';
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 0;
  border-bottom: 6px solid #000000;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

.custom-sellia-tooltip.tooltip.b-tooltip .tooltip-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 12px;
  gap: 8px;
  width: 126px;
  height: 37px;
  background: #000000;
  border-radius: 8px;
  flex: none;
  order: 1;
  flex-grow: 1;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #FFFFFF;
}

</style>